<template>
  <div v-on="$listeners"  class="flex w-full text-gray-400 rounded-full  bg-gray-700 pr-2  items-center text-xs">
    <div>
      <VColorButton :selected="selected" />
    </div>
    <div class="px-1">{{text}}</div>
  </div>
</template>

<script>
export default {
  name: "VPill",
  props: {
    color: { default: "" },
    text: { default: "" },
    selected: { default: false }
  },
  computed: {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.t-col {
  color: rgb(224, 227, 230);
}
</style>
